// src/components/BlogPostCard.js
import React from 'react';
import {
  Box,
  Heading,
  Text,
  Link,
  Image,
  VStack,
  HStack,
  Badge
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { BiBookmark } from 'react-icons/bi';


const BlogPostCard = ({ post }) => {

  const date = post.createdAt.toDate();
  const options = { day: 'numeric', month: 'short', year: 'numeric' };
  const formattedDate = date.toLocaleDateString('en-US', options);
  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit'
  });

  return (
    <Box
      bg="gray.200"
      borderRadius="md"
      boxShadow="md"
      overflow="hidden"
      _hover={{ boxShadow: 'lg', transform: 'translateY(-5px)' }}
      transition="all 0.3s"
    >
      <Box position="relative">
        <Link as={RouterLink} to={`/blog/${post.id}`} title={post.title}>
          <Image
            src={post.imageUrl || 'https://via.placeholder.com/600x200'}
            alt={post.title}
            w="100%"
            h="200px"
            objectFit="cover"
            loading="lazy"
          />
        </Link>
        <Box
          position="absolute"
          bottom="10px"
          left="10px"
          bg="customBlue.500"
          color="white"
          px={3}
          py={1}
          borderRadius="md"
          textAlign="center"
        >
          <Text fontSize="lg" fontWeight="bold">
             {date.getDate()}
          </Text>
          <Text fontSize="sm"> {date.toLocaleString('default', { month: 'short' })} {date.getFullYear()}</Text>
        </Box>
      </Box>
      <VStack p={6} align="start" spacing={4}>
        <HStack spacing={4}>
          <Badge colorScheme="blue" px={2} py={1} mt={-3} borderRadius="full">
            {post.category}
          </Badge>
          <Text fontSize="sm" color="gray.500">
            By {post.author}
          </Text>
        </HStack>
        <Link as={RouterLink} to={`/blog/${post.id}`}>
          <Heading
            as="h3"
            fontSize="lg"
            color="customBlue.500"
            _hover={{ color: 'customBlue.600' }}
          >
            {post.title}
          </Heading>
        </Link>
      </VStack>
    </Box>
  );
};

export default BlogPostCard;